import React, { useState } from 'react'
import { Box } from '@mui/system'
import styled from '@emotion/styled' 
import { Alert, Avatar, Button, Checkbox, Divider, FormControlLabel, Snackbar, TextField, Typography } from '@mui/material'
import { useFormik } from "formik";
import * as yup from "yup";
import api from '../../api/authApi'
import { useNavigate } from 'react-router-dom';
const StyledForm=styled("form")(({theme})=>({
  padding:'20px',
  display:'flex',
  flexDirection:'column',
  gap:'20px',
}))
const BackGround=styled(Box)(({theme})=>({
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   padding:'30px',
   height:'100vh',
   width:'100vw',  
   background:theme.palette.secondary.lighter,
}))
const SignInCard=styled(Box)(({theme})=>({
    minWidth:'30%',
    minHeight:'60%',
    background:theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
    borderRadius:'10px',
    padding:'10px',
}))
const LogoContainer = styled('span')(({theme})=>({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent:'center',
    cursor:'pointer',
    span: {
        fontSize: '34px',
        fontWeight: '600',
    },
    marginLeft:'10px',
    paddingBottom:'40px',
    borderBottom: `0.5px solid ${theme.palette.third.light}`,
}))
const Header=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    padding:"15px",
    color: theme.palette.third.main,
    fontWeight: '400',
    fontSize: '15px',
}))
const StyledTypography = styled(Box)(({theme})=>({
   display:'flex',
   width:'fit-content',
   justifyContent:'flex-end',
   textDecoration:'underline',
   cursor:'pointer',
   marginLeft:'80%',
   color:theme.palette.third.main,
   "&:hover":{
     color:theme.palette.secondary.main,

   }
}))
export default function ResetPassword() {
const [open,setOpen]=useState(false)
const [success,setSuccess]=useState(false)
const navigate=useNavigate()
const validationSchema = yup.object({
  email: yup.string()
    .email("Enter the correct Email")
    .required("Email is required"),

});
const formik = useFormik({
    initialValues: {
      email:'',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      api
          .post("/resetRequest", {email:values.email})
          .then((response)=>{
            setOpen(true)
            setSuccess(response.data.success)
          })
    },
  });
  return (
    <BackGround>
        <SignInCard>
             <LogoContainer >
                <Avatar src="/images/aastulogo.png" sx={{ width: 40, height: 40 }} />
                <span>ASLMS</span>
            </LogoContainer>

            <StyledForm onSubmit={formik.handleSubmit}>
               <TextField
                fullWidth
                type="email"
                label="Email"
                id="email"
                name="email"
                onBlur={formik.handleBlur}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.errors.email && formik.touched.email }
                helperText={formik.touched.email && formik.errors.email}
              />
              {
                open &&
                   ( success?
                      <Alert severity="success" onClose={() => {setOpen(false)}}>
                        Email has been sent, Please Check
                        </Alert>:
                      <Alert severity="error"  onClose={() => {setOpen(false)}}>
                        The email has not found in any records
                      </Alert>)
                    }
              <Button
              type="submit"
              size="large"
              sx={{
                   bgcolor:'secondary.main',
                   fontWeight: 400,
                   color:'#fff',
                  "&:hover":{
                   bgcolor:'secondary.hover',}, } }
              >
                Send Email
              </Button>
            </StyledForm>
            <Divider/>
            <Header>
                A link will be sent to the input email if there is an ALMS account associated with it.
            </Header>
              <StyledTypography onClick={()=>{navigate('/login')}}>
              Sign In
            </StyledTypography>
        </SignInCard>
       {/* <Snackbar open={open} autoHideDuration={6000} onClose={()=>setOpen(false)}>
            <Alert severity="success">Email has been sent if ALMS account exists</Alert>
        </Snackbar> */}
    </BackGround>
  )
}
